import moment from "moment";

export default {
    data(){
        return{
            mostraErro: false,
            erroMensagem: "",
            search: "",
            isLoading: false,
            pagination: { rowsPerPage: 25 },
            textoTabela: "Não há dados a serem exibidos",
            money: {
              decimal: ",",
              thousands: ".",
              prefix: "R$ ",
              precision: 2,
              masked: false,
            },
            customToolbar: [
              ["bold", "italic", "underline"],
              [{ list: "ordered" }, { list: "bullet" }],
              //['image', 'code-block']
            ],
        };
    },
    methods : {
        alertaSucesso(msg){
            this.$swal.fire({
                position: "center",
                type: "success",
                title: msg,
                showConfirmButton: false,
                timer: 3500
            });
        },
        alertaErro(msg){
            this.$swal.fire({
                position: "center",
                type: "error",
                title: msg,
                showConfirmButton: true,
            });
        },
        alertaAtencao(msg){
            this.$swal.fire({
                position: "center",
                type: "warning",
                title: msg,
                showConfirmButton: true,
            });
        },
        padronizaData(data) {
            return data ? moment(String(data)).format("DD/MM/YYYY") : "";
        },
        padronizaHora(data) {
          return data ? moment(String(data)).format("HH:mm") : "";
        },
        padronizaValor(valor) {
            return 'R$ ' + parseFloat(valor).toFixed(2).replace('.',',')
        },
        limpaObjeto(objToClear){
          Object.keys(objToClear).forEach((param) => {
            if ( (objToClear[param]).toString() === "[object Object]" ) {
                clearObjectValues(objToClear[param]);
            } else {
                objToClear[param] = undefined;
            }
          })
          return objToClear;
        },
        fechaAlert(state){
            this.mostraErro = state;
        },
        numberToReal(numero) {
            let num = parseFloat(numero).toFixed(2).split('.');
            num[0] = "R$ " + num[0].split(/(?=(?:...)*$)/).join('.');
            num[0] = num[0].replace('-.','-')
            return num.join(',');
        },
        centavos(valor) {
          return (valor / 100).toFixed(2).replace(".", ",");
        },
        soma(array, param){
            let total = 0;
            array.map(obj => {
                total += parseFloat(obj[param])
            })
            return total;   
        },
        statusAtivo(status) {
          return (status) ? 'Ativo' : 'Desativado'
        },
        media(array, param){
            let total = 0;
            array.map(obj => {
                total += parseFloat(obj[param])
            })
            return (total/array.length); 
        },
        sort(array, type){
            let loop;
            let n = array.length - 1;
            let x = array;
            if(type == 'decrescente'){
                do{
                    loop = false;
                    for(let i = 0; i < n; i++){
                      if(x[i].data < x[i + 1].data){
                        let temp = x[i]
                        x[i] = x[i + 1]
                        x[i + 1] = temp
                       
                        loop = true
                      }
                    }
                    n--;
                  }while(loop)
            }else{
                do{
                    loop = false;
                    for(let i = 0; i < n; i++){
                      if(x[i].data > x[i + 1].data){
                        let temp = x[i]
                        x[i] = x[i + 1]
                        x[i + 1] = temp
                       
                        loop = true
                      }
                    }
                    n--;
                  }while(loop)
            }
            
            return x
          },
          date_to_timestemp(data){
            return data.split('/')[2]+'-'+data.split('/')[1]+'-'+data.split('/')[0]
          },
          pontoEmVirgula(data){
            return (data) ? data.replace('.',',') : data;
          },
          virgulaEmPonto(data){
            return (data) ? data.replace(',','.') : data;
          },
          capitalize(s){
            if (typeof s !== 'string') return ''
            return s.charAt(0).toUpperCase() + s.slice(1)
          },
          negativeNumbers(number){
              if(number < 0){
                  return 'negative-values'
              }else{
                  return
              }
          },

     return_mes(mesNumero) {
      let meses = {
        "01": "Janeiro",
        "02": "Fevereiro",
        "03": "Março",
        "04": "Abril",
        "05": "Maio",
        "06": "Junho",
        "07": "Julho",
        "08": "Agosto",
        "09": "Setembro",
        "10": "Outubro",
        "11": "Novembro",
        "12": "Dezembro"
      };
      return meses[mesNumero];
    },
    retornaStatus(idStatus, arrayStatus) {

      let idStatusDesejado = arrayStatus.findIndex(
        x => x.id == idStatus
      );
      return arrayStatus[idStatusDesejado].nome;
    },
    removeDups(names) {
        let unique = {};
        names.forEach(function(i) {
          if(!unique[i]) {
            unique[i] = true;
          }
        });
        return Object.keys(unique);
      },
    elimina_iguais(array){
        let items = [];
        array.map(obj => {
            items.push(obj.conta_corrente)
        })
        return this.removeDups(items)
    },
       
    scrollToTop() {
        window.scrollTo(0, 0);
    },

    formataTextoEmNumeral(value) {
      let val = (value / 100).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  },
    padronizaStatusAssinante(status){
      switch(status){
        case 'active':
          return 'Ativo'
        case 'overdue':
          return 'Atrasado'
        case 'canceled':
          return 'Cancelado'
        case 'error':
          return 'Erro'
        case 'suspended':
          return 'Suspenso'
        default:
          return 'default'
      }
    },

    copyContent(icon, valueToBeCopied){
      const element = document.createElement('textarea');
      element.value = valueToBeCopied;
      element.setAttribute('readonly', '');
      element.style.position = 'absolute';                     
      element.style.left = '-9999px'; 
      document.body.appendChild(element);
      const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;
      element.select();
      document.execCommand('copy');                 
      document.body.removeChild(element);
      if (selected) {                                 
        document.getSelection().removeAllRanges();    
        document.getSelection().addRange(selected);   
      }
      icon.setAttribute('title', 'Copiado!');
      setTimeout( () => {
        icon.setAttribute('title', 'Clique para copiar');
      }, 2000);
    }
    }
}